import { getStatusControlPin } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getRegion } from 'utils/Region';
import { useDebounce } from './../../../hooks/useDebounce';
import {
  clearKeywordSearch,
  getPopularSearches,
  getSearchResults,
} from './../redux/actions/searchActions';
import { fetchRecordingList } from 'containers/Player/actions/recording/recording.actions';
import { getQuantity } from './../utils/getQuantity';
import { isKidProfile } from './../utils/isKidProfile';
import { jsonParseCatch } from 'utils/getTranslation';

//Este hook se encarga de hacer todas las operaciones relacionadas a las acciones de busqueda
//Principalmente regresa los resultados
export const useGetSearchResults = searchValue => {
  const { debounceValue } = useDebounce(searchValue, 500);
  const byrFilterlist =
    useSelector(state => state.metadata?.byr_filterlist_configuration) || '';
  const token = useSelector(state => state.user.token);
  const userHash = useSelector(state => state.user.userhash);
  const popularSearches = useSelector(
    state => state.search.searchResults.popular,
  );
  const blockedChannels = useSelector(
    state =>
      state.cvEpg.channelBlocker.statusControlPin?.data?.pin_channel?.info,
  );
  const epg_version = useSelector(state => state?.epgVersion?.epg_version);
  const dispatch = useDispatch();
  const perfiles = useSelector(state => state.profilesManager?.profilesInfo?.members);
  const { gamification_id } = useSelector(state => state.user) || {};
  const quantityDefault = getQuantity();
  const isKid = isKidProfile(perfiles, gamification_id);

  //Busquedas populares
  useEffect(
    () => {
      if (debounceValue.length > 0) return;
      dispatch(
        getPopularSearches({
          filterlist: jsonParseCatch(byrFilterlist)?.[getRegion()]?.filterlist,
          token,
          user_hash: userHash,
          epg_version,
          quantity: quantityDefault.ranking,
          is_kids: isKid,
        }),
      );
    },
    [debounceValue, isKid],
  );

  //Accion de busqueda por parametro del input
  useEffect(
    () => {
      dispatch(
        getSearchResults({
          value: searchValue,
          filterlist: jsonParseCatch(byrFilterlist)?.[getRegion()]?.filterlist,
          token,
          user_hash: userHash,
          epg_version,
          quantity: quantityDefault.predictve,
          is_kids: isKid,
        }),
      );
      //Accion para limpiar la keyword
      dispatch(clearKeywordSearch());
    },
    [debounceValue],
  );

  //Realizar las busquedad de canales que estan bloqueados
  useEffect(() => {
    dispatch(getStatusControlPin());
  }, []);

  //Determinar los eventos grabados
  useEffect(() => {
    dispatch(fetchRecordingList({ user_token: token }));
  }, []);

  return { debounceValue };
};
